import { render, staticRenderFns } from "./videoSlideComponent.vue?vue&type=template&id=7f956854"
import script from "./videoSlideComponent.vue?vue&type=script&lang=js"
export * from "./videoSlideComponent.vue?vue&type=script&lang=js"
import style1 from "./videoSlideComponent.vue?vue&type=style&index=1&id=7f956854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports